import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { AutoComplete } from "primereact/autocomplete";
import axios from "axios";
import URLUtils from "../../utilities/URLUtils";
import { getRootComponent } from "../../utilities/ElementUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
  touched: boolean;
  suggestions;


}
export class AutoCompleteComponent extends React.Component<Props, State> {

  suggestions;
  constructor(props: Props) {
    super(props);

    this.state = {

      touched: false,
      suggestions: this.suggestions,
    };
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }
  onAutoChange = (e) => {

    this.props.field.Value = e.value;

    this.props.callbackElement(getRootComponent(this.props.field));
  }

  getSuggestion = (event) => {

    let results = this.suggestions.filter((item) => {
      return item.toLowerCase().indexOf(event.query.toLowerCase()) != -1;
    });


    this.setState({ suggestions: results });
    // this.props.callbackElement(subSection);
  }
  async componentWillMount() {
    if (this.props.field.Datatype == 'AutoComplete') {
      let api = this.props.field.Api
      let res = await axios.get(URLUtils.concatUrls(api), { withCredentials: true });
      let data = res.data;
      let suggestions = data.map(p => p.description + '-' + p.code);
      this.suggestions = suggestions;
      this.setState({ suggestions: suggestions });
    }
  }

  render() {
    let field = this.props.field;
   
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
   
    let isCounterDisplay = field.counterVisible;

    let lengthAndRow = field.Length;
    let numOfRow = 5;
    let maxLength = 500;

    isCounterDisplay = false;
    isCounterDisplay = field.counterVisible;

    lengthAndRow = field.Length;
    numOfRow = 5;
    maxLength = 500; if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
      let arr = lengthAndRow.split(",");
      numOfRow = parseInt(arr[0].toString(), 10);
      maxLength = parseInt(arr[1].toString(), 10);
    } else if (lengthAndRow) {
      maxLength = parseInt(lengthAndRow);
    }

    if (editable) {
      if (isCounterDisplay) {
        controlArray.push(
          <div key={'fd_' + field.Id}>
            <div key={'fdLbl_auto_' + field.Id} id={'fdLbl_auto_label' + field.Id} >
              {labelControlArray}
            </div>
            <div key={'fdIpt_div_' + field.Id} >
              {/* @ts-ignore */}
              <AutoComplete style={{ width: '100%' }}
                id={'fdIpt_' + field.Id} key={'fdIpt_' + field.Id} inputClassName={classNames('ontario-input ontario-dropdown form-input-width-medium', { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField && this.state.touched })} onBlur={() => this.setState({ touched: true })}
                value={this.props.field.Value} aria-labelledby={'fdLbl_auto_label' + field.Id}
                suggestions={this.state.suggestions} onChange={this.onAutoChange} completeMethod={this.getSuggestion.bind(this)} />

              <div style={{ color: "red" }} className="invalid-feedback" id={"invalid-feedback_" + field.Id} />
              <div className="word-count">{this.valueLength(field.Value)}/{maxLength}</div>
            </div>
          </div>);
      } else {
        controlArray.push(
          <div key={'fd_' + field.Id}>
            <div key={'fdLbl_div_' + field.Id} >
              {labelControlArray}
            </div>
            <div key={'fdIpt_div_' + field.Id} >
              {/* @ts-ignore */}
              <AutoComplete style={{ width: '100%' }} inputClassName='ontario-input ontario-dropdown form-input-width-medium'
                id={'fdIpt_' + field.Id} key={'fdIpt_' + field.Id}
                value={this.props.field.Value}
                suggestions={this.state.suggestions} onChange={this.onAutoChange} completeMethod={this.getSuggestion.bind(this)} />
              <div style={{ color: "red" }} className="invalid-feedback" id={"invalid-feedback_" + field.Id} />
            </div>
          </div>);
      }

    } else {
      controlArray.push(
        <div className='pdf-two-column'>
          <div>{field.ENUTitle}</div>
          <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{field.Value}</div>
        </div>
      )
    };

    return controlArray;
  }
}